import { useEffect, useState } from "react";

const SECTION_THEME = {
  hero: "dark",
  values: "dark",
  mission: "light",
  services: "dark",
  products: "dark",
  works: "dark",
  insights: "dark",
  clients: "light",
  contact: "dark",
};

/**
 * Returns "dark" (white text needed) or "light" (dark text needed)
 * based on the currently visible section / route.
 * On detail pages, defaults to "dark" since hero is dark.
 */
export default function useSectionTheme() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const onScroll = () => {
      // Detail pages: detect background of the topmost visible section
      const sections = document.querySelectorAll("[data-section]");
      if (!sections.length) {
        // Fallback for detail pages — inspect top viewport
        const el = document.elementFromPoint(window.innerWidth / 2, 80);
        if (el) {
          const bg = getComputedStyle(el).backgroundColor || "";
          // crude detection: parse rgb and decide
          const m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (m) {
            const lum = 0.299 * m[1] + 0.587 * m[2] + 0.114 * m[3];
            setTheme(lum > 140 ? "light" : "dark");
            return;
          }
        }
        setTheme("dark");
        return;
      }

      // Home: determine which section is at the top
      const probe = 80;
      let currentId = "hero";
      sections.forEach((sec) => {
        const r = sec.getBoundingClientRect();
        if (r.top <= probe && r.bottom > probe) {
          currentId = sec.dataset.section || sec.id || "hero";
        }
      });
      setTheme(SECTION_THEME[currentId] || "dark");
    };

    onScroll();
    // Listen on the snap-root if present, otherwise window
    const scroller = document.querySelector(".snap-root") || window;
    scroller.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      scroller.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return theme;
}
